<template>
  <div id="content" class="crpg-o-tokyo-calender-club-common gourmet">
    <div
      id="detail"
      class="crpg-o-tokyo-calender-club-common__detail gourmet_3"
    >
      <AtomsCommonTopicpath />
      <MoleculesCommonContentTitleRed :title="content.title" />
      <AtomsCommonItemNumber :itemNumber="content.puroduct_no" />
      <div class="pic_1">
        <img :src="contentTopImage" alt="" />
      </div>
      <div class="doc">
        <div class="catch">{{ content.contentTitle }}</div>
      </div>
      <dl v-for="item in content.content" :key="item.image">
        <MoleculesTokyoCalenderSpeciality
          :contentTitle="item.contentSmallTitle"
          :contentText="item.contentText"
          :image="item.image"
        />
      </dl>
      <div class="apply">
        <span class="btn-box">
          <span class="s newline">{{ content.contentOther }}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import AtomsCommonTopicpath from "@/components/atoms/common/Topicpath.vue";
import MoleculesCommonContentTitleRed from "@/components/molecules/common/ContentTitleRed.vue";
import AtomsCommonItemNumber from "@/components/atoms/common/ItemNumberL.vue";
import MoleculesTokyoCalenderSpeciality from "@/components/molecules/tokyoCalenderClub/Specialty.vue";

import text from "@/assets/txt/tokyo_calender_club.json";

var textDate = text;

export default {
  name: "TokyoCalenderClubCommon",
  components: {
    AtomsCommonTopicpath,
    MoleculesCommonContentTitleRed,
    AtomsCommonItemNumber,
    MoleculesTokyoCalenderSpeciality,
  },
  data() {
    return {
      content: textDate,
      contentTopImage: require("@/assets/img/tokyo_calender.jpg"),
    };
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/organisms/tokyoCalenderClub/tokyoCalenderClubContent.scss";
</style>
